import {useCallback, useEffect, useState} from 'react';
import type {
  AppleAuthResponse as AppleAuthResponseFromLib,
  AppleSignInButtonProps,
} from 'react-apple-signin-auth';
import AppleSigninModule from 'react-apple-signin-auth';

// workaround after moved to vite@8
const AppleSignin = (
  'default' in AppleSigninModule ? AppleSigninModule.default : AppleSigninModule
) as React.ComponentType<AppleSignInButtonProps>;

import {twMerge} from 'tailwind-merge';

import {APPLE_OAUTH_REDIRECT_URL} from '@/shared/config';
import {useDeviceType} from '@/shared/hooks/useDeviceType';

type AppleOauthButtonProps = {
  className?: string;
} & Pick<
  AppleSignInButtonProps,
  'onSuccess' | 'onError' | 'buttonExtraChildren'
>;

export type AppleAuthResponse = AppleAuthResponseFromLib;

export function useIsSupportedAppleOauthButton(onlyClientRender = false) {
  const deviceType = useDeviceType(onlyClientRender);
  const checkIsSupported = useCallback(
    (type: ReturnType<typeof useDeviceType>) => {
      if (type === 'iOS') {
        return true;
      }

      return type === 'Mac';
    },
    []
  );
  const [isSupported, setIsSupported] = useState(checkIsSupported(deviceType));

  useEffect(() => {
    setIsSupported(checkIsSupported(deviceType));
  }, [deviceType, checkIsSupported]);

  return isSupported;
}

export default function AppleOauthButton({
  className = '',
  ...props
}: AppleOauthButtonProps) {
  return (
    <AppleSignin
      className={twMerge('rounded-lg!', className)}
      authOptions={{
        clientId: 'app.bumpy',
        scope: 'email',
        redirectURI: APPLE_OAUTH_REDIRECT_URL,
        state: 'state',
        nonce: 'nonce',
        usePopup: true,
      }}
      uiType="light"
      {...props}
    />
  );
}
